/**
 * Wind Speed Color Ranges
 *
 * Defines color ranges for different wind speeds to provide visual indication
 * of wind intensity in the weather dashboard.
 *
 * Format:
 * Each entry is an array containing:
 * [windSpeed, [R, G, B]] where:
 * - windSpeed: Threshold wind speed in km/h
 * - [R, G, B]: RGB color values for that speed range
 *
 * Color Progression:
 * - Calm winds (0-4 km/h): Light blue
 * - Light breeze (4-11 km/h): Medium blue
 * - Moderate breeze (11-18 km/h): Teal
 * - Fresh breeze (18-25 km/h): Green
 * - Strong breeze (25-32 km/h): Dark green
 * - Near gale (32-40 km/h): Yellow
 * - Gale (40-47 km/h): Orange
 * - Strong gale (47-54 km/h): Red
 * - Storm (54-61 km/h): Purple
 * - Violent storm (61-68 km/h): Pink
 * - Hurricane (68+ km/h): Gray
 *
 * Usage:
 * - Used by WindCompass and WindDirectionIllustration components
 * - Provides visual feedback about wind intensity
 * - Helps users quickly assess wind conditions
 */

export const colorRanges = [
  [0, [98, 113, 183]],
  [4, [57, 97, 159]],
  [11, [74, 148, 169]],
  [18, [77, 141, 123]],
  [25, [83, 165, 83]],
  [32, [53, 159, 53]],
  [40, [167, 157, 81]],
  [47, [159, 127, 58]],
  [54, [161, 108, 92]],
  [61, [129, 58, 78]],
  [68, [175, 80, 136]],
  [76, [117, 74, 147]],
  [86, [109, 97, 163]],
  [97, [68, 105, 141]],
  [104, [92, 144, 152]],
  [130, [125, 68, 165]],
  [166, [231, 215, 215]],
  [184, [219, 212, 135]],
  [277, [205, 202, 112]],
  [374, [128, 128, 128]],
];
